import styles from './TypingIndicator.module.css';

export interface TypingIndicatorProps {
  /** Peer first name shown in the pill ("Дарія пише…"). */
  name: string;
}

/**
 * Small "X пише…" pill with animated 3-dot indicator. Rendered above the
 * composer on the chat thread when the peer's `chat.typing` event arrived
 * within the last few seconds (see F-150 spec).
 */
export function TypingIndicator({ name }: TypingIndicatorProps): JSX.Element {
  return (
    <div className={styles.pill} role="status" aria-live="polite">
      <span className={styles.label}>{name} пише</span>
      <span className={styles.dots} aria-hidden="true">
        <span className={styles.dot} />
        <span className={styles.dot} />
        <span className={styles.dot} />
      </span>
    </div>
  );
}
